<template>
  <BarChart
    :request-status="requestStatus"
    :categories="categories"
    :series="series"
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BarChart from '@/components/cards/models/BarChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import ratingModel from '@/mixins/rating-model';
import { POST_FIELDS } from '@/services/charts-service';

const STARS_ORDER = [5, 4, 3, 2, 1];
const POSTS_LIMIT = 1000;

export default {
  name: 'GoogleMyBusinessRatingsByStars',
  components: {
    BarChart,
  },
  mixins: [
    ratingModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      categories: [],
      series: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    buildSeries(posts, isSilentRefresh) {
      const counters = STARS_ORDER.reduce((acc, star) => ({ ...acc, [star]: 0 }), {});

      posts.forEach((post) => {
        const star = Number(post[POST_FIELDS.RATING]);
        if (counters[star] !== undefined) {
          counters[star] += 1;
        }
      });

      this.categories = STARS_ORDER.map(star => `${star} ★`);
      this.series = [
        {
          name: this.$t('components.GoogleMyBusinessRatingsByStars.label.series'),
          data: STARS_ORDER.map(star => ({
            y: counters[star],
            color: this.getRatingColor(star),
          })),
        },
      ];
      this.requestStatus = 'success';

      if (isSilentRefresh) {
        EventBus.$emit('updated', { itemId: this.itemId });
      }
    },
    getData(options) {
      const isSilentRefresh = options && options.silentRefresh;

      if (!isSilentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'topPosts',
        serviceParams: {
          limit: POSTS_LIMIT,
        },
      })
        .then((response) => {
          const posts = (response && response.posts) || [];
          this.buildSeries(posts, isSilentRefresh);
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
